exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\nmat-toolbar{\r\n    margin-bottom:5px;\r\n}\r\n\r\nmat-form-field {\r\n    padding: 5px;\r\n}\r\n\r\n.mat-form-field {\r\n    width: 270px !important;\r\n}\r\n\r\n.long-form-field {\r\n    width: 98% !important;\r\n}\r\n\r\n.error {\r\n    color: red;\r\n}\r\n\r\n.mat-dialog-content {\r\n    max-height: none;\r\n    height: 100%\r\n}\r\n\r\n.ptag {\r\n    color: red;\r\n    font-size: small;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/programs-edit/programs-edit.component.css
// module id = ../../../../../src/app/loanprograms/programs-edit/programs-edit.component.css
// module chunks = main